import { Atom } from "effect/unstable/reactivity"

/** True when the browser exposes `navigator.gpu`. Adapter/device acquisition can still fail. */
export const webgpuSupported = Atom.make(
  () => typeof navigator !== "undefined" && "gpu" in navigator,
)

/** Tracks `prefers-reduced-motion` live. */
export const reducedMotion = Atom.make((get) => {
  if (typeof window === "undefined") return false
  const query = window.matchMedia("(prefers-reduced-motion: reduce)")
  const onChange = () => get.setSelf(query.matches)
  query.addEventListener("change", onChange)
  get.addFinalizer(() => query.removeEventListener("change", onChange))
  return query.matches
})
